export const smoothScrollTo = (targetPosition, start, duration = 800) => {
  const change = targetPosition - start
  let startTime

  const animation = (currentTime) => {
    if (startTime === undefined) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const newY = easeOutExpo(timeElapsed, start, change, duration)
    window.scrollTo(0, newY)
    if (timeElapsed < duration) {
      requestAnimationFrame(animation)
    }
  }

  requestAnimationFrame(animation)
}

function easeOutExpo(t, b, c, d) {
  return c * (-Math.pow(2, -10 * t / d) + 1) + b
}

